import { all, call, put, select } from 'typed-redux-saga';
import {
  createOrder,
  getInitialPatients,
} from '../../../services/e-calendar/reservation-form/reservation-form-service';
import TStore from '../../../types/store';
import {
  getDisplayedDates,
  getPatientOptionsFromResponse,
  handleApiError,
} from './reservation-form-saga.utils';
import { actions } from '../../ducks/reservation-form-slice';
import { ReservationFormValues } from '../../../types/reservation-form';
import { IPatientSelectOption } from '@hilbi/web-common/components/e-visits/select/options/types';

export function* setupReservationAddForm() {
  try {
    const providerId: string = yield select((state: TStore) => state.users.business[0].id);
    const { patientOptionsResponse } = yield* all({
      patientOptionsResponse: call(getInitialPatients, providerId),
    });
    const event = yield* select((state: TStore) => state.reservationForm.event);
    const { displayedDateTime, displayedDate } = getDisplayedDates(event);

    yield* put(
      actions.updateReservationForm({
        patientOptions: getPatientOptionsFromResponse(patientOptionsResponse),
        displayedDateTime,
        displayedDate,
        timeRangePickerHidden: false,
      }),
    );

    yield* put(
      actions.setInitialFormValues({
        timeRangePickerValue: {
          fromTime: event.start,
          toTime: event.end,
        },
        selectedTag: event.tag
          ? {
              value: event.tag.id,
              label: event.tag.name,
              color: event.tag.color,
            }
          : null,
        description: event.description || '',
      }),
    );

    yield* put(actions.setFormState('idle'));
  } catch (error) {
    yield* call(handleApiError, { error });
  }
}

export function* submitReservationAddForm({ payload }: { payload: ReservationFormValues }) {
  try {
    const { event } = yield* select((state: TStore) => ({
      event: state.reservationForm.event,
    }));

    const providerId = yield* select((store: TStore) => store.users.business[0].id);
    // @ts-expect-error it is defined
    const workspaceId = yield* select((store: TStore) => store.eVisits.selectedInstitution.id);

    yield* put(actions.setFormState('submitting'));

    yield* call(createOrder, providerId, {
      clientId: (payload.selectedPatient as IPatientSelectOption)?.value || null,
      title: payload.title,
      // from: eventData.fromTime,
      // to: eventData.toTime,
      description: payload.description,
      workspaceId,
      // @ts-ignore
      eventId: event.eventId,
      tagId: payload.selectedTag?.value || undefined,
    });
    yield* put(actions.setFormState('submit_success'));
  } catch (error) {
    yield* call(handleApiError, { error });
  }
}
